import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col } from 'react-bootstrap';
import './Footer.css'; // Assuming the CSS is saved in a file named Nav.css

import logo from './Images/vegboxlogo.svg'


const NewFooter = () => {
    return (
      <footer className="text-center">
          <div className="row justify-content-center align-items-center my-3">
            {/* Footer copyright */}
            <div className="col-12 col-md-auto footer-copyright text-center">
              ©2026 VEGBOX - ALL RIGHTS RESERVED
            </div>
  
            {/* Footer links */}
            <div className="col-12 col-md-auto">
              <a href="/about-us" className="footer-link">About us</a>
            </div>
            <div className="col-12 col-md-auto">
              <a href="/jobs" className="footer-link">Jobs</a>
            </div>
            <div className="col-12 col-md-auto">
              <a href="/contact" className="footer-link">Contact</a>
            </div>
            <div className="col-12 col-md-auto">
              <a href="/privacy-policy" className="footer-link">Privacy Policy</a>
            </div>
            <div className="col-12 col-md-auto">
              <a href="https://www.instagram.com/vegbox.ch/?hl=en" target="_blank" rel="noreferrer" className="footer-link">Instagram</a>
            </div>
            <div className="col-12 col-md-auto">
              <a href="/legal" className="footer-link">Legal</a>
            </div>
            <div className="col-12 col-md-auto">
              <a href="/impressum" className="footer-link">Impressum</a>
            </div>
          </div>
      </footer>
    );
  };
  
  
export default NewFooter;
